import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageMoveService } from 'src/app/service/page-move.service';

@Component({
  selector: 'app-recruit-detail',
  templateUrl: './recruit-detail.component.html',
  styleUrls: ['./recruit-detail.component.css']
})
export class RecruitDetailComponent implements OnInit {

  
  _notice:any;

  _jobDescriptions:Array<String> = [];
  _essentialSkills:Array<String> = [];
  _extraSkills:Array<String> = [];

  _link:any;
  
  constructor(
    private pageMove:PageMoveService,
    private cdr: ChangeDetectorRef,
    private route:ActivatedRoute
  ) {
    this.notice = this.pageMove.notice;
    if(this.notice){
      if (this.notice.jobDescription) {
        this.jobDescriptions = this.notice.jobDescription.split('\n'); 
      }
      if (this.notice.essentialSkill){
        this.essentialSkills = this.notice.essentialSkill.split('\n');
      }
      if (this.notice.extraSkill){
        this.extraSkills = this.notice.extraSkill.split('\n');
      }
      if(this.notice.link){
        this.link = this.notice.link
      }
    }
  
    setTimeout(() => {
      this.cdr.detectChanges();
    });  
   }

  ngOnInit(): void {

      window.scrollTo(0,0);
  }
  set link(val) {
    this._link = val;
  }
  get link() {
    return this._link;
  }

  set notice(val) {
    this._notice = val;
  }
  get notice() {
    return this._notice;
  }

    set jobDescriptions(val) {
    this._jobDescriptions = val;

  }

  get jobDescriptions() {
    return this._jobDescriptions;
  }

  set essentialSkills(val) {
    this._essentialSkills = val;

  }

  get essentialSkills() {
    return this._essentialSkills;
  }

  set extraSkills(val) {
    this._extraSkills = val;

  }

  get extraSkills() {
    return this._extraSkills;
  }

  linkTo(){
    let openNewWindow = window.open(this.link,"about:blank");
  }

  ngOnDestroy(){
  }

}
